import { render, staticRenderFns } from "./ANZBUTTONMIDDLE.vue?vue&type=template&id=51b4bb3c"
import script from "./ANZBUTTONMIDDLE.vue?vue&type=script&lang=js"
export * from "./ANZBUTTONMIDDLE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports